import {Controller} from '@hotwired/stimulus';

/**
 * Envoie le formulaire qui le porte depuis un élément qui n'est pas un bouton d'envoi.
 *
 *   <form {{ stimulus_controller('form-submit') }}>
 *     <select {{ stimulus_action('form-submit', 'submit', 'change') }}>…</select>
 *     <a href="#" {{ stimulus_action('form-submit', 'requestSubmit:prevent') }}>…</a>
 *   </form>
 *
 * `submit` envoie comme `this.form.submit()` : sans événement `submit` ni validation des champs.
 * `requestSubmit` passe par l'événement `submit`, donc par ses écouteurs (`submit-confirm`), comme le
 * `.submit()` de jQuery, et valide en plus les champs.
 */
export default class extends Controller {
  // par le prototype : un champ nommé `submit` masque la méthode du formulaire
  submit() {
    HTMLFormElement.prototype.submit.call(this.element);
  }

  requestSubmit() {
    HTMLFormElement.prototype.requestSubmit.call(this.element);
  }
}
